var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDummyTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 53,
    viewBox: "0 0 209 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.801 52.8322C186.142 52.8322 193.742 45.3779 193.978 36.0933L193.988 17.0628C194.197 8.80315 200.236 1.99205 208.143 0.588898C207.042 0.588898 205.94 0.591438 204.839 0.59523L204.854 0.587841H4.60216L4.62222 0.599453C3.22668 0.593384 1.83169 0.588898 0.4375 0.588898C8.34443 1.99222 14.3829 8.80329 14.5921 17.0628L14.6026 36.0933C14.8378 45.3779 22.4384 52.8322 31.7796 52.8322H176.801Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyTop);
export default __webpack_public_path__ + "static/media/dummy_top.7d9fc5165f6d8a1f64ddc9570852c618.svg";
export { ForwardRef as ReactComponent };